import { render, staticRenderFns } from "./couponTable.vue?vue&type=template&id=35c3853c&scoped=true"
import script from "./couponTable.vue?vue&type=script&lang=js"
export * from "./couponTable.vue?vue&type=script&lang=js"
import style0 from "./couponTable.vue?vue&type=style&index=0&id=35c3853c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c3853c",
  null
  
)

export default component.exports